import { useEffect, useState } from "react";
import {
  Box,
  Divider,
  Icon,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";

import { IDetailsBoleto } from "interfaces/detailsBoleto";
import { IDetailsPix } from "interfaces/detailsPix";

import DetailsPix from "./DetailsPix";
import DetailsBoleto from "./DetailsBoleto";

// imagens
import iconBoleto from "assets/images/icons/bol.png";
import iconPix from "assets/images/icons/pix.png";
import iconCartao from "assets/images/icons/car.png";
import { IDetailsCartaoEfi } from "interfaces/detailsCartao";
import DetailsCartao from "./DetailsCartao";

type PaymentDetails = IDetailsBoleto | IDetailsPix | IDetailsCartaoEfi | null;

const getPaymentType = (paymentDetails: PaymentDetails) => {
  if (!paymentDetails) return null;

  if ("data" in paymentDetails) {
    if (paymentDetails.data.payment.method === "banking_billet")
      return "Boleto";
    if (paymentDetails.data.payment.method === "credit_card") return "Cartão";
  }
  if ("txid" in paymentDetails) return "Pix";

  return null;
};

interface Props {
  paymentDetails: PaymentDetails;
}

export default function ModalDetailsPay({ paymentDetails }: Props) {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(!open);

  useEffect(() => {
    paymentDetails && setOpen(true);
  }, [paymentDetails]);

  const typePayment = getPaymentType(paymentDetails) || "";

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box
        sx={{
          ...style,
          width: { xs: "90vw", sm: "80vw" },
          p: 3,
          position: "relative",
        }}
      >
        <MDBox
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <MDBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <img
              src={
                typePayment === "Pix"
                  ? iconPix
                  : typePayment === "Boleto"
                    ? iconBoleto
                    : iconCartao
              }
              width={90}
              alt="Pagamento"
            />
            <Typography variant="h4">{`Detalhe de pagamento - ${typePayment.toUpperCase()}`}</Typography>
          </MDBox>
          <IconButton onClick={handleClose}>
            <Icon>close</Icon>
          </IconButton>
        </MDBox>
        <Divider sx={{ my: 1 }} />
        {typePayment === "Pix" && (
          <DetailsPix detailsPix={paymentDetails as IDetailsPix} />
        )}
        {typePayment === "Cartão" && (
          <DetailsCartao detailsCartao={paymentDetails as IDetailsCartaoEfi} />
        )}
        {typePayment === "Boleto" && (
          <DetailsBoleto detailsBoleto={paymentDetails as IDetailsBoleto} />
        )}
      </Box>
    </Modal>
  );
}

const style = {
  position: "absolute" as "absolute",
  borderRadius: "5px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};
